define(
  'modules/text-pre-processor',
  [
    'jquery'
  ],
  function (
    $
  ) {
    'use strict';

    var toSplit = [
      {
        selector: '.js-anim-reveal-1-text',
        separator: ' ',
        fragmentStyle: 'display:inline-block;opacity:0;margin-right:1rem'
      }
    ];

    function init () {
      splitFragments();
    }

    function splitFragments () {
      for (var i = 0; i < toSplit.length; i++) {
        var item = toSplit[i];
        var $elem = $(item.selector);
        var fragments = $elem.text().split(item.separator);
        var newHtml = '';

        for (var f = 0; f < fragments.length; f++) {
          newHtml += '<span class="' + item.selector.replace('.', '') + '-fragment" style="' + item.fragmentStyle + '">' + fragments[f] + '</span>';
        }

        $elem.html(newHtml);
      }
    }

    return {
      init: init
    }
});

